// extracted by mini-css-extract-plugin
export default {"AppAboutUs":"AppAboutUs_AppAboutUs__8-E1K","AppAboutUs__content":"AppAboutUs_AppAboutUs__content__UWNHP"};